import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AnalyticsMonth } from '../../domain/models/analytics-period.model';
import { AnalyticsSummary } from '../../domain/models/analytics-summary.model';
import { IAnalyticsRepository } from '../../domain/repositories/analytics.repository';
import { AnalyticsRemoteDatasource } from '../datasources/remote/analytics.remote-datasource';
import { AnalyticsMapper } from '../mappers/analytics.mapper';

@Injectable()
export class AnalyticsRepositoryImpl implements IAnalyticsRepository {
  private readonly datasource = inject(AnalyticsRemoteDatasource);
  private readonly mapper = inject(AnalyticsMapper);

  public getSummary(period: AnalyticsMonth, departmentId?: number): Observable<AnalyticsSummary> {
    return this.datasource.getSummary(period, departmentId).pipe(map((dto) => this.mapper.toAnalyticsSummary(dto)));
  }
}
